import { useMutation, useQueryClient } from "@tanstack/vue-query";
import { ApiResponse } from "@/utils/ApiResponse";
import { ProveedorInterface } from "../../interfaces/proveedorInterfaces/Proveedor.interface";
import { useToast } from "vue-toastification";
import { DeleteProveedorAction } from "../../actions/proveedorActions";

const toast = useToast();

export function useProveedorDelete(onClose?: () => void) {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: (proveedorId: string) => DeleteProveedorAction(proveedorId),

    onSuccess:async (response: ApiResponse<ProveedorInterface>) => {
      await queryClient.invalidateQueries({ queryKey: ["ProveedoresList"] });
      toast.success("El proveedor fue eliminado correctamente");
       if (onClose) onClose();
    },

    onError: (error: unknown) => {
      toast.error("Error al eliminar el proveedor");
        if (onClose) onClose();
    },
  });

  return {
    ...mutation, // => { mutate, mutateAsync, isPending, isError, error, isSuccess, data }
  };
}
